import { Navigate, RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { RoutePaths } from '@utils/route.utils.ts';

const DepartmentsAndUnitsComponent = lazy(
  () => import('./departments-and-units.tsx')
);
const DepartmentsComponent = lazy(
  () => import('./pages/departments/departments.tsx')
);
const UnitsComponent = lazy(() => import('./pages/units/units.tsx'));

export const departmentsAndUnitsRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <DepartmentsAndUnitsComponent />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Navigate
            to={RoutePaths.Core.DepartmentsAndUnits.Departments.absolutePath}
            replace
          />
        )
      },
      {
        path: RoutePaths.Core.DepartmentsAndUnits.Departments.path,
        element: (
          <Suspense>
            <DepartmentsComponent />
          </Suspense>
        )
      },
      {
        path: RoutePaths.Core.DepartmentsAndUnits.Units.path,
        element: (
          <Suspense>
            <UnitsComponent />
          </Suspense>
        )
      }
    ]
  }
];
